var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 4H14V2C14 1.46957 13.7893 0.960859 13.4142 0.585786C13.0391 0.210714 12.5304 0 12 0H8C6.89 0 6 0.89 6 2V4H2C0.89 4 0 4.89 0 6V17C0 17.5304 0.210714 18.0391 0.585786 18.4142C0.960859 18.7893 1.46957 19 2 19H18C18.5304 19 19.0391 18.7893 19.4142 18.4142C19.7893 18.0391 20 17.5304 20 17V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4ZM8 2H12V4H8V2ZM10 7C10.663 7 11.2989 7.26339 11.7678 7.73223C12.2366 8.20107 12.5 8.83696 12.5 9.5C12.5 10.163 12.2366 10.7989 11.7678 11.2678C11.2989 11.7366 10.663 12 10 12C9.33696 12 8.70107 11.7366 8.23223 11.2678C7.76339 10.7989 7.5 10.163 7.5 9.5C7.5 8.83696 7.76339 8.20107 8.23223 7.73223C8.70107 7.26339 9.33696 7 10 7ZM15 17H5V15.75C5 14.37 7.24 13.25 10 13.25C12.76 13.25 15 14.37 15 15.75V17Z",
    fill: "#3699FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendor);
export default __webpack_public_path__ + "static/media/Vendor.800d14b6.svg";
export { ForwardRef as ReactComponent };